import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('p4f_lang') || 'ar');
  const isAr = lang === 'ar';

  useEffect(() => {
    localStorage.setItem('p4f_lang', lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = isAr ? 'rtl' : 'ltr';
  }, [lang, isAr]);

  const t = useCallback((key, vars) => {
    const entry = translations[key];
    let s = entry ? entry[isAr ? 1 : 0] : key;
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
    return s;
  }, [isAr]);

  const pick = useCallback((obj, field) => {
    if (!obj) return '';
    return isAr ? (obj[`${field}_ar`] || obj[field] || '') : (obj[field] || obj[`${field}_ar`] || '');
  }, [isAr]);

  const locale = isAr ? 'ar-BH-u-nu-latn' : 'en-GB';
  const fmtDate = useCallback((d, opts) => new Date(d).toLocaleDateString(locale, opts || { year: 'numeric', month: 'short', day: 'numeric' }), [locale]);
  const fmtDateTime = useCallback((d) => new Date(d).toLocaleString(locale, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }), [locale]);
  const toggleLang = () => setLang(prev => (prev === 'ar' ? 'en' : 'ar'));

  return (
    <LanguageContext.Provider value={{ lang, isAr, setLang, toggleLang, t, pick, fmtDate, fmtDateTime }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
